import { FC, useState } from 'react'
import ChangePasswordInputs from '../../components/ChangePasswordInputs/ChangePasswordInputs'
import {
  alertStyle,
  successTransitionStyle,
  textFooterStyle,
  titleStyle,
  WrapperCard
} from './ChangePasswordForm.styles'
import AuthHeader from '../../../../ui/containers/AuthHeader/AuthHeader'
import { useTranslation } from 'react-i18next'
import { Alert, Typography } from 'antd'
import { passwordConfig } from './ChangePasswordForm.constants'
import { useAuth } from '../../../../../../../../auth/Auth.hook'
import { ChangePasswordFormData } from '../../components/ChangePasswordInputs'
import { userChangePassword } from '../../../../../../../../domain/user-profile/user-profile.services'
import CardSuccess from '../../components/CardSuccess/CardSuccess'

const { Text } = Typography

interface ChangePasswordFormProps {
  title?: string
  description?: string
  textFooter?: string
  showHeader?: boolean
  showFooter?: boolean
}

const ChangePasswordForm: FC<ChangePasswordFormProps> = ({
  title,
  description,
  textFooter,
  showHeader = true,
  showFooter = true
}) => {
  const { t } = useTranslation()
  const { userInfo, logout } = useAuth()
  const [isSuccess, setIsSuccess] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handlerContinue = () => {
    logout()
  }

  const handlerChangePassword = async (values: ChangePasswordFormData) => {
    try {
      setIsError(false)
      setIsSubmitting(true)
      const { new_password, confirm_new_password } = values
      const { user } = userInfo
      await userChangePassword(user.id, { newPassword: new_password, currentPassword: confirm_new_password })
      setIsSuccess(true)
      setTimeout(() => {
        handlerContinue()
      }, 3000)
    } catch (err) {
      console.error('Error changing password:', err)
      setIsError(true)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <WrapperCard>
      {isSuccess ? (
        <div style={successTransitionStyle}>
          <CardSuccess onContinue={handlerContinue} />
        </div>
      ) : (
        <>
          {showHeader && (
            <AuthHeader
              title={title ?? t('user-profile.second-table.title')}
              titleStyle={titleStyle}
              description={description ?? t('change-password-description')}
            />
          )}
          {isError && (
            <Alert
              message={t('error_change_password')}
              type='error'
              closable
              style={{
                ...alertStyle,
                animation: !isError ? 'slideOutUp 0.3s ease-in-out forwards' : 'slideInDown 0.3s ease-in-out'
              }}
            />
          )}
          <ChangePasswordInputs
            loading={isSubmitting}
            disabled={isSubmitting}
            onSubmit={handlerChangePassword}
            validationConfig={passwordConfig}
          />
          {showFooter && <Text style={textFooterStyle}>{textFooter ?? t('thank_helping_platform_safe')}</Text>}
        </>
      )}
    </WrapperCard>
  )
}

export default ChangePasswordForm
